"use client";

import { useEffect } from "react";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const analyticsKey = process.env.NEXT_PUBLIC_ANALYTICS_KEY;
    const hasKey =
      analyticsKey &&
      analyticsKey.trim().length > 0 &&
      analyticsKey !== "undefined" &&
      analyticsKey !== "null";

    if (
      typeof window !== "undefined" &&
      window.location.hostname === "codepathfinder.dev" &&
      hasKey
    ) {
      import("posthog-js").then(({ default: posthog }) => {
        posthog.init(analyticsKey, {
          api_host: "https://us.i.posthog.com",
          person_profiles: "identified_only",
          capture_pageview: true,
          capture_pageleave: true,
          autocapture: true,
        });
      });
    }
  }, []);

  return <>{children}</>;
}
